import { Box, Button, Paper, Typography, useTheme } from '@mui/material'

import { Icons } from '../../utils/icons.jsx'
import warningImg from '../../../shared/assets/warning.svg'
import { useNavigate } from 'react-router-dom'


const FallbackErrorBoundary = ( { error, resetErrorBoundary } ) => {

    const navigate = useNavigate()
    const { theme } = useTheme()

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `url('/imgs/bg-pattern1.png')`,
                height: "100vh",
                width: "100vw"
            }}>
            {/* Dark mode overlay */}
            {theme === 'dark' && (
                <Box sx={{
                    zIndex: 1,
                    background: "rgba(0,0,0,0.8)",
                    position: "absolute",
                    inset: 0
                }} />
            )}

            <Paper
                elevation={3}
                sx={{
                    zIndex: 10,
                    padding: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    maxWidth: "450px",
                    gap: "20px",
                    borderRadius: "12px"
                }}
            >
                {/* Image Placeholder */}
                <Box
                    component="img"
                    src={warningImg}
                    alt="Access Denied"
                    sx={{ width: "200px", height: "auto", mb: 2 }}
                />

                <Box>
                    <Typography variant="h5" color="error" gutterBottom sx={{
                        fontWeight: "700"
                    }}>
                        An unexpected error occurred.
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        We’re having trouble loading this page. Please try again or reach out to support if the problem persists.
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        gap: "15px",
                        width: "100%",
                        justifyContent: "center",
                        mt: 1
                    }}>
                    <Button
                        variant="outlined"
                        startIcon={Icons.default.ArrowBack}
                        onClick={() => navigate( -1 )}
                        sx={{ textTransform: 'none' }}
                    >
                        Go Back
                    </Button>
                    <Button
                        variant="contained"
                        disableElevation
                        startIcon={Icons.default.Replay}
                        onClick={resetErrorBoundary}
                        sx={{ textTransform: 'none' }}
                    >
                        Refresh
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}

export default FallbackErrorBoundary